import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { toast } from 'react-toastify';

const StudentAttendance = () => {
  const { id,id2,id3} = useParams() ;
  const [loader, setLoader] = useState(true);
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [students, setStudents] = useState([]);



  useEffect(() => {
    fetchAllStudentInCourse(id);
   
  }, [id]);

  const fetchAllStudentInCourse = () => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/student-attendence?studentId=${id3}&courseId=${id2}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.attendance && Array.isArray(result?.attendance)) {
          setStudents(result?.attendance); // Set students to the `data` array
        } else {
          setStudents([]); // Set students to an empty array if `data` is missing or not an array
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error('Failed to fetch students'); // Notify user of error
      })
      .finally(() => {
        setLoader(false); // Stop loading
      });
  };


 


  const ApproveFee = (link) => {
    setIsModelLoading(true);

    const requestOptions = {
      method: 'PATCH',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/fee-mark-paid/${link?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === false) {
          toast.error(data?.error);
          setIsModelLoading(false);
        }
        setIsModelLoading(false);
        toast.success('Fee is Paid');
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error);
        setIsModelLoading(false);
      });
  };

  const closeModal = () => {
    setIsSlipModalOpen(!isSlipModalOpen);
  };

  return (
    <section className="mb-20 mt-7">
      <div className="rounded-lg overflow-x-auto">
        {loader ? ( 
          <Loader />
        ) : students.length > 0 ? (
          <div className="flex flex-col">
            <div className="sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden">
                <table className="min-w-full mb-0">
                            <thead className="">
                              <tr className="rounded-lg whitespace-nowrap">
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4"
                                >
                                  Student
                                </th>
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4"
                                >
                                  Course
                                </th>
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4"
                                >
                                  Session Time
                                </th>
                                <th
                                  scope="col"
                                  className="text-sm text-primary font-bold px-6 py-4"
                                >
                                  Mark Attendance
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {students?.map((record) => (
                                <tr
                                  key={record._id}
                                  className="bg-white border-b-8 border-white rounded-md"
                                >
                                  <td className="align-middle bg-white text-sm font-normal px-6 py-3 text-center">
                                    <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {record.student}
                                    </span>
                                  </td>
                                  <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                                    <span className="text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                      {record.course}
                                    </span>
                                  </td>
                                  <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                    {record.sessionTime?.map((item, index) => (
                                      <span
                                        key={index}
                                        className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full"
                                      >
                                        {`${item.startTime} - ${item?.endTime}`}
                                      </span>
                                    ))}
                                  </td>
                                  <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                    <span
                                      className={`text-base py-1 px-2.5 leading-none whitespace-nowrap rounded-md ${
                                        record.status === 'Present'
                                          ? 'bg-[#DFF7E3] text-[#23A118]'
                                          : record.status === 'Absent'
                                            ? 'bg-[#FFE4E4] text-[#FF0000]'
                                            : record.status === 'Hold'
                                              ? 'bg-[#FFF3E0] text-[#FFA500]'
                                              : record.status === 'Leave'
                                                ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                                : 'bg-gray-200 text-black'
                                      }`}
                                    >
                                      {record.status}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                  
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Show "No students found" message if data is empty
          <div className="text-center py-10">
            <p className="text-gray-500">No students found for this Attendance.</p>
          </div>
        )}
      </div>

      {/* Fee Slip Modal */}
      {isSlipModalOpen && (
        <>
          {console.log('GAMe', singleData)}
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={closeModal}
          >
            <div
              className="bg-white p-6 rounded overflow-y-auto h-[60vh] shadow-lg max-w-xl w-full relative"
              onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
            >
              {/* X Icon for closing */}
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
              >
                ✕
              </button>

              <h2 className="text-lg font-bold mb-4">Fee Slip</h2>

              <div className="w-full mb-6">
                <img
                  src={singleData?.feeStatus?.slipUrl}
                  alt="Fee Slip"
                  className="w-full h-auto rounded mb-4"
                />
              </div>

              <div className="flex justify-end gap-4">
                {/* Cancel Button */}
                <button
                  onClick={closeModal}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>

                {/* Approve Button */}
                <button
                  onClick={() => ApproveFee(singleData)}
                  className="px-4 py-2 bg-[#FF7E00] text-white rounded"
                  disabled={isModelLoading} // Disable button during loading
                >
                  {isModelLoading ? (
                    <div className="spinner-border animate-spin w-5 h-5 border-t-2 border-white rounded-full" />
                  ) : (
                    'Approve'
                  )}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default StudentAttendance;
